import {IStorageService} from './storage.service.interface';
import {ILoggerService} from '../logger/logger.service.interface';

export class StorageService implements IStorageService {

  constructor(private _logger: ILoggerService) {

  }

  getItem(key: string) {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(key, value);
  }


  getJson(key: string): any {
    let value = this.getItem(key);
    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (err) {
      this._logger.error(`Failed to parse to JSON the local storage key ${key} with value ${value}`, err);
      return null;
    }
  }

  setJson(key: string, value: object): void {
    this.setItem(key, JSON.stringify(value));
  }


  removeItem(key: string): void {
    localStorage.removeItem(key);
  }


  createCookie(name: string, value: string): void {
    var now = new Date();
    now.setFullYear(now.getFullYear() + 1);
    document.cookie = name + '=' + value + ';domain=.888casino.com;expires=' + now['toGMTString']() + ';path=/';
  }

  getCookie(name: string) {
    let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
    if (match) {
      return match[1];
    }
  }

  removeCookie(name: string): void {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.888casino.com;";
  }
}
